/**
 * Check if two sessions have overlapping time periods
 * @param {Object} session1 - First session with startTime and endTime
 * @param {Object} session2 - Second session with startTime and endTime  
 * @returns {boolean} - True if sessions overlap
 */
export function sessionsOverlap(session1, session2) {
  const start1 = new Date(session1.startTime)
  const end1 = new Date(session1.endTime)
  const start2 = new Date(session2.startTime)
  const end2 = new Date(session2.endTime)

  // Check for overlap: session1 starts before session2 ends AND session1 ends after session2 starts
  return start1 < end2 && end1 > start2
}

/**
 * Find conflicts between a new session and existing starred sessions
 * @param {Object} newSession - Session being added
 * @param {Array} existingSessions - Array of currently starred sessions
 * @returns {Array} - Array of conflicting sessions
 */
export function findConflicts(newSession, existingSessions) {
  return existingSessions.filter(session => 
    session.id !== newSession.id && sessionsOverlap(newSession, session)
  )
}

/**
 * Generate a user-friendly conflict message
 * @param {Array} conflicts - Array of conflicting sessions
 * @returns {string} - Human readable conflict message
 */
export function generateConflictMessage(conflicts) {
  if (conflicts.length === 0) return ''
  
  if (conflicts.length === 1) {
    return `Heads up! This session overlaps with "${conflicts[0].title}" in your plan.`
  }
  
  return `Heads up! This session overlaps with ${conflicts.length} other sessions in your plan.`
} 